import React from 'react';
import Form from 'react-bootstrap/Form';
import { useForceUpdate } from '../util';
import NumericInput from 'react-numeric-input';
import { FigureInfo } from '../controls/ImageInfo';
import { TabContextReporter } from '../TabContext';
export default function Figure(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Image Information"
  }, /*#__PURE__*/React.createElement(FigureInfo, props), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Height:")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 80,
    max: 2000,
    value: parseInt(dataProps.style.height, 10),
    onChange: e => {
      dataProps.style.height = `${e}px`;
      forceUpdate();
      props.onChanged();
    }
  }))));
}